module.exports = __webpack_public_path__ + "media/images/cueva-2-ce194746b15ecfe8b203eb9ca1da1d4b.jpg";